import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/api";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
];

/** Bouton unique « Générer synthèse » (MEDECIN / IDE) — PDF à la volée, ouvert dans un nouvel onglet. */
export default function CareSummaryButton({ patientId }) {
  const [loading, setLoading] = useState(false);

  const generate = async (lang) => {
    setLoading(true);
    const popup = window.open("", "_blank");
    try {
      const res = await api.get(`/patients/${patientId}/care-summary.pdf`, { params: { lang }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const summaryId = res.headers?.["x-hana-summary-id"];
      if (popup) {
        popup.location.href = url;
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.download = `${summaryId || "synthese-hana"}.pdf`;
        link.click();
      }
      toast.success(summaryId ? `Synthèse ${summaryId} générée` : "Synthèse générée");
    } catch (err) {
      if (popup) popup.close();
      toast.error(err?.response?.status === 403 ? "Accès non autorisé à ce patient" : "Impossible de générer la synthèse");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          disabled={loading}
          data-testid="generate-care-summary-btn"
          className="flex items-center gap-2 bg-white hover:bg-slate-50 text-slate-700 border border-slate-200 font-medium px-3.5 py-2 rounded-xl text-sm transition-colors disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
          Générer synthèse
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" data-testid="care-summary-lang-menu">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onSelect={() => generate(l.code)} data-testid={`care-summary-lang-${l.code}`}>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
